import { render, staticRenderFns } from "./ResultsTableAction.vue?vue&type=template&id=5b7bb8ac"
import script from "./ResultsTableAction.vue?vue&type=script&lang=js"
export * from "./ResultsTableAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports